export enum PersonelTuru{
    sys_adm= 1,
    kurucu_avukat,
    idari_yonetici,
    avukat ,
    stajyer_avukat ,
    baskatip ,
    katip ,
    muhasebe ,
    sekreter ,
    diger
}
export enum PersonelTuruLabel{
    "Sistem Yöneticisi" = 1,
    "Kurucu Avukat" = 2,
    "İdari Yönetici" = 3,
    "Avukat",
    "Stajyer Avukat",
    "Başkatip",
    "Katip",
    "Muhasebe",
    "Sekreter",
    "Diğer"
}


